import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'rule-list',
    template: require('./rule-list.component.html'),
    styles: [require('./rule-list.component.scss')]
})
export class RuleListComponent {

    @Input() public processData: any;
    @Input() public get rules() {
        return this._rules;
    }
    
    public selectRuleByName(targetRule: any)
    {                
        this._rules.forEach(rule => {
            if (rule.name === targetRule.category.Value) {
                rule.isSelected = true;
                rule.value.forEach(val => {
                    if(val.name === targetRule.name)
                        val.selected = true;                   
                    
                });               
            }
        });        
    }    

    public set rules(rules) {
        if (rules) {
            this._rules = rules.sort((a, b) => {
                if (a.isNew) return -1;
                if (b.isNew) return 1;
                return (a.name > b.name) ? 1 : -1;
            });
        }
    }
    // tslint:disable-next-line:variable-name
    public _rules: any;

    @Output() public onAddRule: EventEmitter<void> = new EventEmitter<void>();
    @Output() public onGetRule: EventEmitter<any> = new EventEmitter<any>();
  
    constructor() {
    }

    public getRule(selectedItem: any, indexInList: any): void {
        this.onGetRule.emit({ selectedItem, indexInList });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/policyEngine/rules-management/rule-list/rule-list.component.ts